<template>
      <BreadCrumb PageTitle=" Ajouter une place" />
    <AddPlace/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddPlace from "@/components/Place/AddPlace.vue";
  
    export default defineComponent({
      name: "AddPlacePage",
      components: {
        BreadCrumb ,
        AddPlace,
      },
    });
  </script>